export default "__VITE_ASSET__DminUukS__"